import { Icon } from '@/components/Icon';
import { Link } from '@/components/Link';
import { StandaloneComponent } from '@/types/component';
import { ArticlePaywallFormProps, StandaloneArticlePaywallForm } from 'base/components/standalone/ArticlePaywallForm';
import KlarnaBadgeLogo from 'base/public/image/klarna-badge.png';
import NextImage from 'next/image';

export const FeminaStandaloneArticlePaywallForm: StandaloneComponent<ArticlePaywallFormProps> = (props) => {
  return (
    <StandaloneArticlePaywallForm
      button="Fortsätt till betalning"
      headline="Vill du läsa hela artikeln?"
      features={[
        <>
          <Icon name="check" options={{ className: 'mt-0.5 flex-shrink-0' }} />
          Obegränsad tillgång till alla artiklar, spännande livshistorier och djupgående intervjuer
        </>,
        <>
          <Icon name="check" options={{ className: 'mt-0.5 flex-shrink-0' }} />
          Upp till 30 exklusiva artiklar per månad, bara för dig som Plus kund
        </>,
        <>
          <Icon name="check" options={{ className: 'mt-0.5 flex-shrink-0' }} />
          Exklusivt nyhetsbrev med våra bästa lästips ingår
        </>,
      ]}
      caption={
        <>
          Redan prenumerant? <br className="md:hidden" />
          <Link
            target="_blank"
            href="https://login.allermedia.se/?return=https%3A%2F%2Fwww.femina.se%2F"
            content="Logga in på ditt konto här"
          />
        </>
      }
      policy={
        <>
          Genom köp av prenumeration kommer ett konto skapas till dig. Dina uppgifter kommer hanteras enligt{' '}
          <Link
            content={'Aller Medias personuppgiftspolicy'}
            target="_blank"
            href="https://www.aller.se/integritetspolicy"
          />
          . Ett konto hos oss kostar ingenting.
        </>
      }
      description="Starta din prenumeration av Femina Plus redan i dag, och få allt detta för bara 49 kr i månaden:"
      provider={
        <>
          Betala med
          <NextImage className="h-13 w-20" src={KlarnaBadgeLogo} alt="Klarna logo" />
        </>
      }
      {...props}
    />
  );
};
